import { Box ,Image} from '@chakra-ui/react'
import React from 'react'

export default function HotelList() {
  return (
    <Box data-aos="fade-up" m="auto" w="80%"  mb="5rem"     >
        <Image src="https://assets.website-files.com/5d55f1425cb6b7a18aa77528/62eac351e7c0245d741e737d_logos-1-a-p-1080.png" alt="image"/>
    </Box>
  )
}
